/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getVideo.defs.js";
export { main as default } from "./getVideo.defs.js";
